import { Popover, Box, Typography } from '@mui/material'
import { useState } from 'react'
import { useAppTheme } from '@/theme/ThemeContext'
import type { APICrmStatusOption, CrmSection } from '@/services/crmService'
import { CRM_SECTION_COLORS } from '@/utils/crm'

interface CRMRowModalProps {
  /** Current status name (the row's value). */
  label?: string | null
  /** Section of the current status; drives the badge colour. */
  section?: CrmSection | null
  statuses: APICrmStatusOption[]
  onChange: (statusId: number) => void
  disabled?: boolean
}

const CRMRowModal = ({
  label,
  section,
  statuses,
  onChange,
  disabled = false,
}: CRMRowModalProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    if (disabled) return
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSelect = (statusId: number) => {
    onChange(statusId)
    handleClose()
  }

  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'
  const BG_COLOR = isDarkMode ? '#202B40' : '#F8FAFD'

  return (
    <>
      <Box
        onClick={handleOpen}
        sx={{
          minWidth: '68px',
          width: 'fit-content',
          px: '6px',
          margin: '0 auto',
          textAlign: 'center',
          color: '#EFF2F7',
          borderRadius: '3.643px',
          height: '19.429px',
          marginTop: '15px',
          lineHeight: '19.429px',
          cursor: disabled ? 'default' : 'pointer',
          whiteSpace: 'nowrap',
          backgroundColor: section ? CRM_SECTION_COLORS[section] : '#C0C2D6',
        }}
      >
        {label || (disabled ? '-' : 'בחירה')}
      </Box>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Box pt={1} px={3} bgcolor={BG_COLOR} border="none">
          {statuses.map(option => (
            <Box
              key={option.id}
              onClick={() => handleSelect(option.id)}
              sx={{
                height: '30px',
                textAlign: 'center',
                marginBottom: '8px',
                backgroundColor: CRM_SECTION_COLORS[option.section],
                borderRadius: '4.5px',
                paddingTop: '5px',
                paddingBottom: '8px',
                color: '#EFF2F7',
                cursor: 'pointer',
              }}
              px={1}
            >
              <Typography
                sx={{
                  fontFamily: 'Rubik, sans-serif',
                  fontSize: '14px',
                  fontStyle: 'normal',
                }}
              >
                {option.name}
              </Typography>
            </Box>
          ))}
        </Box>
      </Popover>
    </>
  )
}

export default CRMRowModal
